import {DateTime} from "luxon";

const DEVICE_SERIAL_NUMBER_PREFIX = "TOE";

export function formatRecordedWith(deviceSerialNumber: string | undefined): string {
  if (!deviceSerialNumber) {
    return "";
  }

  return `${DEVICE_SERIAL_NUMBER_PREFIX}${deviceSerialNumber}`;
}

export function formatPercentageWithDuration(percentage: string, duration: string): string {
  const formattedPercentage = formatPercentage(percentage);

  if (!formattedPercentage) {
    return duration;
  }

  if (!duration) {
    return formattedPercentage;
  }

  return `${formattedPercentage} (${duration})`;
}

export function formatPercentage(percentage: string): string {
  if (!percentage) {
    return "";
  }

  return `${percentage} %`;
}

export function formatAmountWithIndex(amount: string, index: string, reportLanguage: string): string {
  if (!amount) {
    return "";
  }

  return `${formatReportNumber(amount, reportLanguage)} (${formatReportNumber(index, reportLanguage)})`;
}

export function formatReportNumber(value: string, reportLanguage: string): string {
  const number = Number(value);

  if (!value || isNaN(number)) {
    return value;
  }

  const fractionDigits = fractionDigitsOf(value);

  return new Intl.NumberFormat(reportLanguage, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(number);
}

function fractionDigitsOf(value: string): number {
  return value.split(".")[1]?.length ?? 0;
}

const REPORT_DATE_OPTIONS: Intl.DateTimeFormatOptions = {year: "numeric", month: "2-digit", day: "2-digit"};
const REPORT_TIME_OPTIONS: Intl.DateTimeFormatOptions = {hour: "2-digit", minute: "2-digit"};

export function formatReportDate(isoDate: string, reportLanguage: string): string {
  const dateTime = DateTime.fromISO(isoDate).setLocale(reportLanguage);

  if (!dateTime.isValid) {
    return "";
  }

  return dateTime.toLocaleString(REPORT_DATE_OPTIONS);
}

export function formatReportDateTime(isoDateTime: string, reportLanguage: string): string {
  const dateTime = DateTime.fromISO(isoDateTime).setLocale(reportLanguage);

  if (!dateTime.isValid) {
    return "";
  }

  return `${formatReportDate(isoDateTime, reportLanguage)} ${dateTime.toLocaleString(REPORT_TIME_OPTIONS)}`;
}
